import { j as t } from "../../chunks/jsx-runtime.DGlMoOmv.js";
import { c as h } from "../../chunks/index.C4-GUKyp.js";
import * as l from "react";
import { FormattedMessage as o } from "react-intl";
import { B as p } from "../../chunks/Button.Ccj-dDdM.js";
import { T as s } from "../../chunks/Text.BGhoO_e3.js";
import { F as u } from "../../chunks/X16.DHZc2Acw.js";
import { c as i } from "../../chunks/index.CxSWpsOB.js";
const v = (e, r) => /* @__PURE__ */ t.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, fill: "currentColor", viewBox: "0 0 20 20", ref: r, ...e, children: /* @__PURE__ */ t.jsx("path", { fill: "currentColor", d: "M9.754 3.042a.75.75 0 0 1 .57.032l6.234 2.992.017.008.067.036.007.005a.746.746 0 0 1 .187.169l.013.015a.747.747 0 0 1 .064.103l.01.022a.737.737 0 0 1 .039.097l.007.02A.75.75 0 0 1 17 6.75v6.5a.75.75 0 0 1-.426.675l-6.234 2.992a.748.748 0 0 1-.652.014l-.006-.003c-.002 0-.004 0-.006-.002l-6.25-3A.75.75 0 0 1 3 13.251v-6.5c0-.036.002-.07.007-.105 0-.008.003-.016.005-.023a.75.75 0 0 1 .027-.11l.007-.018a.753.753 0 0 1 .053-.119l.014-.021a.749.749 0 0 1 .06-.084l.023-.026a.747.747 0 0 1 .093-.087c.012-.01.025-.018.038-.027l.026-.017a.747.747 0 0 1 .068-.037l.005-.003 6.25-3 .078-.032ZM4.5 12.779l4.75 2.28v-4.782L4.5 7.953v4.826Zm6.25-2.559v4.838l4.75-2.28V7.94l-4.75 2.28ZM5.468 6.755l4.474 2.19 4.576-2.196L10 4.58 5.468 6.755Z" }) }), w = l.forwardRef(v), j = (e, r) => /* @__PURE__ */ t.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, fill: "currentColor", viewBox: "0 0 20 20", ref: r, ...e, children: [
  /* @__PURE__ */ t.jsx("path", { fill: "currentColor", d: "M13.5 10.432a.5.5 0 0 0 0-.866l-5-2.884a.5.5 0 0 0-.749.433v5.769a.5.5 0 0 0 .75.433l5-2.885Z" }),
  /* @__PURE__ */ t.jsx("path", { fill: "currentColor", d: "M10.001 2.041a7.958 7.958 0 1 0 0 15.917 7.958 7.958 0 0 0 0-15.917ZM3.543 9.999a6.458 6.458 0 1 1 12.917 0 6.458 6.458 0 0 1-12.917 0Z" })
] }), c = l.forwardRef(j), g = h("tw-relative tw-overflow-hidden tw-rounded-4 tw-aspect-[5/4] tw-w-[171px] md:tw-w-[205px]"), b = ({
  type: e,
  label: r
}) => {
  if (!e)
    return null;
  if (r)
    return /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
      e === "video" && /* @__PURE__ */ t.jsx(c, {}),
      e === "3d" && /* @__PURE__ */ t.jsx(w, {}),
      r
    ] });
  switch (e) {
    case "video":
      return /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
        /* @__PURE__ */ t.jsx(c, {}),
        /* @__PURE__ */ t.jsx(s, { typeface: "caption-2-m", children: /* @__PURE__ */ t.jsx(o, { id: "kBJUtE", defaultMessage: [{
          type: 0,
          value: "Video"
        }] }) })
      ] });
    case "3d":
      return /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
        /* @__PURE__ */ t.jsx(w, {}),
        /* @__PURE__ */ t.jsx(s, { typeface: "caption-2-m", children: /* @__PURE__ */ t.jsx(o, { id: "wEDUJc", defaultMessage: [{
          type: 0,
          value: "3D tour"
        }] }) })
      ] });
    case "cover":
    default:
      return /* @__PURE__ */ t.jsx(s, { typeface: "caption-2-m", children: /* @__PURE__ */ t.jsx(o, { id: "j1qOou", defaultMessage: [{
        type: 0,
        value: "Cover photo"
      }] }) });
  }
}, C = ({
  onClick: e
}) => /* @__PURE__ */ t.jsx(p, { className: "tw-absolute tw-w-24 tw-min-w-24 tw-h-24 tw-top-8 tw-right-8 tw-border-0 tw-bg-gray-900 tw-bg-opacity-70 tw-p-4 hover:tw-bg-opacity-100 tw-transition-colors", onClick: e, iconOnly: !0, variant: "text-only", shape: "circle", children: /* @__PURE__ */ t.jsx(u, { className: "tw-text-base-white hover:tw-text-gray-800" }) }), M = l.forwardRef(({
  className: e,
  imageUrl: r,
  onClose: d,
  type: a = void 0,
  altText: n,
  label: x,
  ...m
}, f) => /* @__PURE__ */ t.jsxs("div", { ref: f, className: i(g(), e), ...m, children: [
  /* @__PURE__ */ t.jsx("img", { src: r, alt: n, className: "tw-w-full tw-h-full tw-object-cover" }),
  /* @__PURE__ */ t.jsx(C, { onClick: d }),
  a && /* @__PURE__ */ t.jsx("div", { className: i("tw-absolute tw-h-24 tw-bottom-8 tw-left-8 tw-bg-base-black tw-bg-opacity-70 tw-text-base-white tw-flex tw-items-center tw-gap-4", "tw-rounded-full tw-font-semibold", "tw-py-2", {
    "tw-px-8": a === "cover",
    "tw-pl-4 tw-pr-8": a !== "cover"
  }), children: /* @__PURE__ */ t.jsx(b, { type: a, label: x }) })
] }));
M.displayName = "MediaCard";
export {
  M as MediaCard
};
//# sourceMappingURL=index.js.map
